import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { isEmpty, isNil } from 'lodash';
import { trackError } from 'utils/helpers';
import { PRICING_SECTION, setBookability } from 'redux/actions/availability';
import { useDateRangeBookabilityQuery } from 'redux/api_slice/availability';

// Get price of basic resource and child resources.
// Note: passenger count is always 1.
export const useResourcePrice = ({
  resourceId,
  childResourceIds,
  date,
  passengerTypeIDs,
}) => {
  const pricingSection = PRICING_SECTION.passenger;

  const dispatch = useDispatch();
  const resourceIds = [resourceId, ...childResourceIds];
  const passengerTypeNumbers = passengerTypeIDs.reduce((acc, cur) => {
    acc[cur] = 1;
    return acc;
  }, {});

  const skip = isNil(resourceId) || isNil(date) || isEmpty(childResourceIds);

  const { data, error } = useDateRangeBookabilityQuery(
    {
      resourceIds,
      passengerTypeNumbers,
      fromDate: date,
      toDate: date,
    },
    { skip }
  );

  // Update redux store
  useEffect(() => {
    if (!isNil(data)) {
      const temp = { json: data, pricingSection };
      dispatch(setBookability(temp));
    }
  }, [data, dispatch, pricingSection]);

  useEffect(() => {
    if (!isNil(error)) {
      trackError(error);
    }
  }, [error]);
};
